import { toast } from "react-toastify";
import { endpoints } from "../../configs/Settings";
import { HTTPResponseStatus } from "../../utils/enum";
import { useAuth } from "../../utils/useAuth";
import { useAxios } from "../../utils/useAxios";
import { OAuthApplication } from "../auth";
import { getAuthToken } from "../auth/OAuthApplication";

interface IProps {
  valueset: string;
  version?: "r4" | "r5";
  filter?: string;
  customUrl?: string;
  authType?: string; // Tipo de autenticação: "application" ou padrão (user token)
}

export async function GetValueSet({
  valueset,
  version,
  filter,
  customUrl,
  authType,
}: IProps) {
  let url;

  if (customUrl) {
    url = `${endpoints.TERMINOLOGY}/ValueSet/$expand?url=${customUrl}&count=250`;
  } else {
    url = ` ${
      version === "r5"
        ? `${endpoints.XDSB_domain}/terminology/fhir`
        : endpoints.TERMINOLOGY
    }`;
    if (version)
      url = `${url}/ValueSet/$expand?url=https://fluxmed.com.br/fhir/${version}/ValueSet/${valueset}&count=150`;
    else
      url = `${url}/ValueSet/$expand?url=https://fluxmed.com.br/fhir/ValueSet/${valueset}&count=150`;
  }

  if (filter) url = `${url}&filter=${filter}`;

  const headers = {
    Accept: "*/*",
    Authorization: await getAuthToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetValueSet ${valueset}: ${response.status}`);
      }

      const sortResponse = response?.data?.expansion?.contains?.sort(
        (elemInitial: any, elemCompare: any) =>
          elemInitial?.code > elemCompare?.code ? 1 : -1
      );

      response.data.expansion.contains = sortResponse;

      return { status: HTTPResponseStatus.Success, data: response.data };
    })
    .catch((error) => {
      console.error("GetValueSet ", error);
      // toast.error(`GetValueSet Erro: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
